const stringHelper = {
  isANumber: (someString) => {
    const stringLength = someString.length;
    for (let i = 0; i <= stringLength - 1; i++) {
      const char = someString.substring(i, i + 1);
      if (!stringHelper.isCharacterANumber(char)) {
        return false;
      }
    }
    return true;
  },

  isCharacterANumber: (char) => {
    if (char.length > 1) {
      return false;
    }
    const numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    for (let x of numbers) {
      if (x === char) {
        return true;
      }
    }
    return false;
  },

  formatPhone: (phone) => {
    if (!phone) {
      return;
    }

    if (phone.length !== 10) {
      return phone;
    }
    return (
      "(" +
      phone.substring(0, 3) +
      ") " +
      phone.substring(3, 6) +
      "-" +
      phone.substring(6, 10)
    );
  },

  isNullOrEmpty: (val) => {
    if (val === null || val === "") {
      return true;
    }
    const trimmedVal = val.trim();
    if (trimmedVal === "") {
      return true;
    }
    return false;
  },
};
export default stringHelper;
